<template>
  <Layout />
</template>
<script setup lang="ts">
import Layout from '~/components/layout/BaseLayout.vue'
</script>
